<script lang="ts">
  import { type FacetValue, Chip } from "@otto-ec/heureka-components/facet-value";
  import { OverflowBox } from "@otto-ec/heureka-components/facet-value-group";
  import { type FacetValueLabelOptions, Text } from "@otto-ec/heureka-components/facet-value-label";

  const defaultFacetValueLabelOptions: Partial<FacetValueLabelOptions> = {
    size: "75",
  };

  interface Props {
    filterId?: string;
    values: FacetValue[];
    containsOnlyNbaValues?: boolean;
  }

  const { values, containsOnlyNbaValues }: Props = $props();
</script>

{#snippet chip(facetValue: FacetValue)}
  <Chip {...facetValue}>
    <Text {...facetValue} {...defaultFacetValueLabelOptions} />
  </Chip>
{/snippet}

<div class="hc_nextBestAction">
  <div class="hc_nextBestAction__header">
    {#if containsOnlyNbaValues}BELIEBTE FILTER{:else}BELIEBTE UND GEWÄHLTE FILTER{/if}
  </div>
  <OverflowBox {values} item={chip} />
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .hc_nextBestAction {
    margin-bottom: tokens.$oc-semantic-spacing-50;

    &__header {
      padding: tokens.$oc-semantic-spacing-50 0 tokens.$oc-semantic-spacing-50;
      font: tokens.$oc-semantic-font-copy-75;
      color: tokens.$oc-semantic-color-text-secondary;
    }
  }
</style>
